import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { Headture, FinResource, FinResourceType } from "@app/definitions/types"
import { pluck } from "@app/services/api.service"
import { Modalable } from "@app/Modalable"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { PrintEmailPromptComponent } from "@app/print-email-prompt/print-email-prompt.component"
import { SafeHtmlPipe } from "@app/utils/safe-html.pipe"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import {
	BtnExtComponent,
	CancelBtnComponent,
	TableWrapComponent,
} from "@app/utils/utils.component"
import { PreviewFinresourceComponent } from "@app/preview-finresource/preview-finresource.component"
import { WysiwygComponent } from "@app/utils/wysiwyg/wysiwyg.component"
import { GetHeadtureRowComponent } from "@app/get-headture-row.component"

@Component({
	selector: "app-finresource-translation",
	imports: [
		COMMON_IMPORTS,
		GenInputComponent,
		PrintEmailPromptComponent,
		SafeHtmlPipe,
		TableWrapComponent,
		WysiwygComponent,
		LangValPipe,
		CancelBtnComponent,
		BtnExtComponent,
		PreviewFinresourceComponent,
		GetHeadtureRowComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./finresource-translation.component.html",
})
export class FinresourceTranslationComponent extends Modalable {
	isPreviewOpen: boolean = false
	isGetHeadtureOpen: boolean = false
	headtureRow: any = null
	finresourceObj: any = null
	@Input() objectRow: any = null
	errors: any = {} //will hold errors for the fields in the form
	isFormSubmittable: boolean = false //can submit (controls disabled in the submit button)
	validationFields: any = {
		//field validations, control displaying field errors and ability to submit the form
		paid_by_en: { not_empty: null },
		description_en: { not_empty: null },
	}
	has_payment_details: boolean = true
	bankaccounts: any[] = []
	btnPromptsMode: boolean = false

	async ngOnInit() {
		//get invoice

		const res: any = await this.apiService.post("get_finresource", {
			resource_type: this.objectRow.doctype,
			...pluck(this.objectRow, "id"),
		})
		this.objectRow = { ...res, doctype: this.objectRow.doctype }
		if (this.objectRow.doctype.startsWith("credit")) {
			this.has_payment_details = false
			this.objectRow.payment_details = ""
			this.objectRow.payment_details_en = ""
		}

		if (this.objectRow?.en_version == "yes") {
			this.btnPromptsMode = true
			return
		}

		if (this.objectRow.doctype == "receipt") {
			this.objectRow.invoicelines = this.objectRow.receiptlines
			this.objectRow.invoicelines.forEach(
				(line) => (line.invoice_id = line.receipt_id)
			)
		}
		this.apiService.decryptItem(this.objectRow)
		if (this.objectRow.invoicelines) {
			this.apiService.decryptInCollection(this.objectRow.invoicelines)
		}
		;["paid_by", "description", "payment_details", "remarks"].forEach(
			(field) => {
				this.objectRow[field + "_en"] = this.objectRow[field]
			}
		)
		const prevLang = this.lang.langCode
		this.lang.setLang("en")
		if (this.objectRow?.payment_details_en) {
			this.objectRow.payment_details_en =
				this.objectRow.payment_details_en.replaceAll(
					"מחיר",
					this.lang.getVal("price")
				)
			this.objectRow.payment_details_en =
				this.objectRow.payment_details_en.replaceAll(
					"סוג",
					this.lang.getVal("meetingtype")
				)
			this.objectRow.payment_details_en =
				this.objectRow.payment_details_en.replaceAll(
					"מפגש",
					this.lang.getVal("")
				)
			this.objectRow.payment_details_en =
				this.objectRow.payment_details_en.replaceAll(
					"תאריך",
					this.lang.getVal("date")
				)
			this.objectRow.payment_details_en =
				this.objectRow.payment_details_en.replaceAll(
					"מטפל/ת",
					this.lang.getVal("therapist")
				)
		}

		this.lang.setLang(prevLang)

		let sendObj: any = {
			filterField: null,
			filterFieldValue: null,
		}
		for (let fieldName of ["patient", "contact", "payor"]) {
			fieldName += "_id"
			if (this.objectRow[fieldName]) {
				sendObj.filterField = fieldName
				sendObj.filterFieldValue = this.objectRow[fieldName]
				break
			}
		}

		const res2: any = await this.store.get_gen_items("bankaccounts", sendObj)
		this.bankaccounts = res2.bankaccounts
		this.isGetHeadtureOpen = true
	}

	validateEntireForm() {
		//validate all fields and detrmine if can be submitted (or has errors)
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.objectRow,
			this.errors,
			this.validationFields
		)
	}

	async openPreview() {
		if (this.objectRow.invoicelines) {
			this.objectRow.invoicelines.forEach((il) => {
				if (il.credit_card) {
					il.creditcard = this.store
						.getSiteDataTable("creditcards")
						.find((it) => it.id == il.credit_card)
				}
				if (il.paymentapp_id) {
					il.paymentapp = this.store
						.getSiteDataTable("paymentapps")
						.find((it) => it.id == il.paymentapp_id)
				}
				if (Number(il.account_num)) {
					const bankAccount = this.bankaccounts.find(
						(it) => it.number == il.account_num
					)
					il.bank_name = bankAccount.bank?.name_en
					il.branch_name = bankAccount.branch_id
				}
			})
		}

		;["paid_by", "description", "payment_details", "remarks"].forEach(
			(field) => {
				this.objectRow[field] = this.objectRow[field + "_dec"] =
					this.objectRow[field + "_en"]
			}
		)
		if (this.objectRow.doctype == "proforma") {
			this.objectRow.for = this.objectRow.for_dec = this.objectRow.paid_by
		}

		this.isPreviewOpen = true
	}
}
